import { render } from "./SearchDetailPage.vue?vue&type=template&id=e8ea3ef2&ts=true"
import script from "./SearchDetailPage.vue?vue&type=script&lang=ts"
export * from "./SearchDetailPage.vue?vue&type=script&lang=ts"

import "./SearchDetailPage.vue?vue&type=style&index=0&id=e8ea3ef2&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__